import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ls0002',
    ecrans: ['00-2'],
    params: ['id']
});
